import React from 'react';
import { PinTL, Icon, Button } from '@marvelapp/ui';
import { LAYER_ICON } from '@marvelapp/theme';
export default function LayersButton(_a) {
    var onClick = _a.onClick;
    return (React.createElement(PinTL, { padding: 3 },
        React.createElement(Button, { alignItems: "center", bg: "white", borderRadius: 2, display: "flex", height: "34px", kind: "ghost", lineHeight: "34px", onClick: onClick, paddingLeft: "10px", paddingRight: "12px" },
            React.createElement(Icon, { display: "block", height: 19, marginRight: "6px", paths: LAYER_ICON, viewBox: "0 0 19 19", width: 19 }),
            "Layers")));
}
